export default __webpack_public_path__ + "static/media/120t.a02b48a6.jpg";